/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ credits: NonNullable<unknown> }} Aiflowtotal2Inputs */

const en_aiflowtotal2 = /** @type {(inputs: Aiflowtotal2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Together ${i?.credits} credits`)
};

const de_aiflowtotal2 = /** @type {(inputs: Aiflowtotal2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zusammen ${i?.credits} Credits`)
};

/**
* | output |
* | --- |
* | "Together {credits} credits" |
*
* @param {Aiflowtotal2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowtotal2 = /** @type {((inputs: Aiflowtotal2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowtotal2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowtotal2(inputs)
	return de_aiflowtotal2(inputs)
});
export { aiflowtotal2 as "aiFlowTotal" }